var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defaultParams } from "./params";
import { defaultModifiers, defaultUserAgentModifiers } from "./modifiers";
import { checkIsEmpty, convert, getHideParamsOptions, getUrlParams, } from "./helper";
import { Func, I18n, Media, UI, Container, Source, Share, Account, Collect, } from "./modules";
var Adapter = /** @class */ (function () {
    function Adapter() {
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "hideParamsInUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ignoreKeys", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "ignoreUserAgent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "modifiers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: defaultModifiers
        });
        Object.defineProperty(this, "userAgentModifiers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: defaultUserAgentModifiers
        });
        // 这些是预设的 key，在取出时可能会自动做类型转换，其他的自定义 key 永远是 string 类型
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: defaultParams
        });
        Object.defineProperty(this, "extraParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isInitialized", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // modules
        Object.defineProperty(this, "ui", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "i18n", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "media", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "func", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "source", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "share", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "container", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "account", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "collect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    Object.defineProperty(Adapter.prototype, "init", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (props) {
            if (this.isInitialized) {
                console.warn("adapter has already initialized");
                return;
            }
            var _a = props || {}, hideParamsInUrl = _a.hideParamsInUrl, ignoreKeys = _a.ignoreKeys, ignoreUserAgent = _a.ignoreUserAgent, _b = _a.extraParams, extraParams = _b === void 0 ? [] : _b;
            this.hideParamsInUrl = hideParamsInUrl;
            this.ignoreUserAgent =
                ignoreUserAgent !== undefined ? ignoreUserAgent : false;
            this.extraParams = extraParams;
            this.params = __spreadArray(__spreadArray([], this.params, true), extraParams, true);
            this.ignoreKeys = ignoreKeys || [];
            this.userAgentModifiers = __spreadArray([], this.userAgentModifiers, true);
            // modules
            this.ui = new UI({ adapter: this });
            this.i18n = new I18n({ adapter: this });
            this.media = new Media({ adapter: this });
            this.func = new Func({ adapter: this });
            this.source = new Source({ adapter: this });
            this.share = new Share({ adapter: this });
            this.container = new Container({ adapter: this });
            this.account = new Account({ adapter: this });
            this.collect = new Collect({ adapter: this });
            if (this.ignoreUserAgent === false) {
                this.checkUA();
            }
            this.checkModifiers();
            this.save();
            if (this.hideParamsInUrl) {
                this.clearQueries();
            }
            this.isInitialized = true;
        }
    });
    Object.defineProperty(Adapter.prototype, "isEmpty", {
        get: function () {
            return checkIsEmpty(this.store);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Adapter.prototype, "validValues", {
        // 根据 ignoreKeys params 算出的需要处理的 url 参数 kv 值
        get: function () {
            var _this = this;
            var urlParams = getUrlParams();
            return urlParams.filter(function (_a) {
                var key = _a.key;
                if (_this.ignoreKeys.includes(key)) {
                    return false;
                }
                if (_this.params.some(function (param) { return param.key === key; }) === false) {
                    return false;
                }
                return true;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Adapter.prototype, "getStore", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (this.isEmpty) {
                this.store = this.getDataFromStorage();
            }
            this.params.forEach(function (_a) {
                var key = _a.key, convertTo = _a.convertTo;
                if (convertTo && _this.store[key] !== undefined) {
                    _this.store[key] = convert(convertTo, _this.store[key]);
                }
            });
            return this.store;
        }
    });
    Object.defineProperty(Adapter.prototype, "clearAll", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.store = {};
            this.clearStorage();
        }
    });
    Object.defineProperty(Adapter.prototype, "clearQueries", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var replaceFunc = typeof this.hideParamsInUrl === "object"
                ? this.hideParamsInUrl.replaceFunc
                : undefined;
            var keyList = this.validValues.map(function (_a) {
                var key = _a.key;
                return key;
            });
            var url = new URL(location.href);
            keyList.forEach(function (key) {
                url.searchParams.delete(key);
            });
            if (replaceFunc) {
                replaceFunc(url.href);
                return;
            }
            window.history.replaceState({}, "", url.href);
        }
    });
    Object.defineProperty(Adapter.prototype, "getExtraParams", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return this.extraParams.reduce(function (prev, curr) {
                prev[curr.key] = _this.getStore()[curr.key];
                return prev;
            }, {});
        }
    });
    Object.defineProperty(Adapter.prototype, "setParam", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (key, value) {
            if (this.params.map(function (param) { return param.key; }).includes(key) === false) {
                console.warn("setParam's 1st parameter [key] is not in default params or extraParams when init");
                return;
            }
            var url = new URL(location.href);
            if (url.searchParams.has(key)) {
                url.searchParams.set(key, value + "");
            }
            else {
                url.searchParams.append(key, value + "");
            }
            window.history.replaceState({}, "", url.href);
            this.store[key] = value;
            this.saveToStorage(this.store);
            if (this.hideParamsInUrl) {
                this.clearQueries();
            }
        }
    });
    Object.defineProperty(Adapter.prototype, "save", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            this.validValues.forEach(function (_a) {
                var key = _a.key, value = _a.value;
                _this.store[key] = value;
            });
            if (this.isEmpty === false) {
                this.saveToStorage(this.store);
            }
        }
    });
    Object.defineProperty(Adapter.prototype, "getDataFromStorage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.hideParamsInUrl) {
                return {};
            }
            var _a = getHideParamsOptions(this.hideParamsInUrl), storeKey = _a.storeKey, storeType = _a.storeType;
            var data = window[storeType].getItem(storeKey);
            if (!data) {
                return {};
            }
            try {
                return JSON.parse(data);
            }
            catch (error) {
                // console.error(error);
                this.clearStorage();
                return {};
            }
        }
    });
    Object.defineProperty(Adapter.prototype, "saveToStorage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            if (!data) {
                return false;
            }
            if (!this.hideParamsInUrl) {
                return false;
            }
            var _a = getHideParamsOptions(this.hideParamsInUrl), storeKey = _a.storeKey, storeType = _a.storeType;
            window[storeType].setItem(storeKey, JSON.stringify(data));
            return true;
        }
    });
    Object.defineProperty(Adapter.prototype, "clearStorage", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.hideParamsInUrl) {
                return;
            }
            var _a = getHideParamsOptions(this.hideParamsInUrl), storeKey = _a.storeKey, storeType = _a.storeType;
            window[storeType].removeItem(storeKey);
        }
    });
    Object.defineProperty(Adapter.prototype, "checkModifiers", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var searchParams = getUrlParams();
            var params = searchParams.reduce(function (prev, curr) {
                prev[curr.key] = curr.value;
                return prev;
            }, {});
            this.modifiers.forEach(function (_a) {
                var enable = _a.enable, modifiers = _a.modifiers;
                if (enable) {
                    modifiers.forEach(function (_a) {
                        var key = _a.key, to = _a.to, when = _a.when;
                        if (when && when(params) === false) {
                            return;
                        }
                        _this.store[key] = to;
                    });
                }
            });
        }
    });
    Object.defineProperty(Adapter.prototype, "checkUA", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            this.userAgentModifiers.forEach(function (_a) {
                var ua = _a.ua, modifiers = _a.modifiers;
                if (navigator.userAgent.includes(ua)) {
                    modifiers.forEach(function (_a) {
                        var key = _a.key, to = _a.to;
                        _this.store[key] = to;
                    });
                }
            });
        }
    });
    return Adapter;
}());
export { Adapter };
